import { Component, Input } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";


import { PromptDataModel } from '../../../../../model/general.model';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: []
})
export class PromptDialogComponent {

  @Input() promptData: PromptDataModel;
  @Input() isHtml: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<PromptDialogComponent>,
    private translate: TranslateService
  ) {
  }

  getContent() {
    const key = this.promptData?.content || 'PROMPT.CONTENT';
    return this.translate.instant(key, { param: this.promptData?.contentParam });
  }
}
